import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { SelectInput, StyledRadioInput } from "../../../Helpers/Inputs";
import * as Constants from '../../../Helpers/Constants/States';
import Step4Icon from '../icons/step_4.svg?react';
import IconHolder from "../../../Helpers/IconHolder";

export default function PersonalHistory(props) {

  const { register, setValue, trigger } = props;

  const state = props.basicInfo.state;

  useEffect(() => {
    register('state');
    setValue('state', state);
  }, [register]);

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
    trigger(field);
  };

  const getLabelForBannedCountries = () => {
    if (state === Constants.FLORIDA) {
      return "Within the next 2 years, do you intend to work, travel, or reside in Afghanistan or Iraq for more than 30 days?";
    }
    return "Within the next 2 years, do you intend to work, travel or reside in Saudi Arabia, Iraq, Afghanistan, Syria, Somalia, Sudan, North Korea, Venezuela or Yemen for more than 30 days?";
  };

  return (
    <React.Fragment>
      <Row className='justify-content-center'>
        <IconHolder icon={Step4Icon} viewBox="0 0 25 25" color='primary' />
      </Row>
      <h4 className='headerTitle'>Reviewing Your Personal History</h4>
      <h5 className='headerSubtitle'>Your interests and activities help to determine your personalized rate.</h5>

      <div className="mb-3">
        <StyledRadioInput
          name='extremeSports'
          id='extremeSports'
          label='Within the past 2 years, have you engaged in any motor sports racing, parachuting, skydiving, hang gliding, base jumping, rock or mountain climbing, cave diving or scuba diving over 100 ft?'
          value={props.formState.extremeSports}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('extremeSports', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='flights'
          id='flights'
          label='Within the past 2 years, have you made any flights as a pilot or student pilot?'
          value={props.formState.flights}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('flights', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='felony'
          id='felony'
          label='In the past 5 years, have you been convicted, pled guilty to or currently await trial for a felony?'
          value={props.formState.felony}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('felony', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='bannedCountries'
          id='bannedCountries'
          label={getLabelForBannedCountries()}
          value={props.formState.bannedCountries}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('bannedCountries', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='outsideUS180days'
          id='outsideUS180days'
          label='Within the next 2 years, do you intend to reside outside of the US for more than 180 days?'
          value={props.formState.outsideUS180days}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('outsideUS180days', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='suspendedDriversLicense'
          id='suspendedDriversLicense'
          label='Is your driver’s license currently suspended or revoked?'
          value={props.formState.suspendedDriversLicense}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('suspendedDriversLicense', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='dui5years'
          id='dui5years'
          label='In the past 5 years, have you pled guilty to or been convicted of driving while impaired, intoxicated or under the influence of any drug or alcohol or reckless driving?'
          value={props.formState.dui5years}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('dui5years', e)}
        />
      </div>
      <div className="mb-3">
        <StyledRadioInput
          name='movingViolations5Years'
          id='movingViolations5Years'
          label='In the past 5 years, have you been convicted or pled guilty to any moving violations?'
          value={props.formState.movingViolations5Years}
          options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
          onChange={e => handleValueChange('movingViolations5Years', e)}
        />
      </div>

      {props.formState.movingViolations5Years === "true" &&
        <div className="mb-3">
          <SelectInput
            id='numberofMovingViolations'
            name='numberofMovingViolations'
            value={props.formState.numberofMovingViolations}
            onChange={e => handleValueChange('numberofMovingViolations', e.target.value)}
            label='How many?'
            selectOptions={[{ value: "1", label: "1" }, { value: "2", label: "2" }, { value: "3", label: "3" }, { value: "4", label: "4" }, { value: "5 or more", label: "5 or more" }]}
          />
        </div>
      }
    </React.Fragment>
  );
}

PersonalHistory.propTypes = {
  formState: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  basicInfo: PropTypes.object,
  register: PropTypes.func,
  setValue: PropTypes.func,
  trigger: PropTypes.func,

};

PersonalHistory.ValidationSchema = object().shape({
  extremeSports: string().required('This field is required.'),
  flights: string().required('This field is required.'),
  felony: string().required('This field is required.'),
  bannedCountries: string().required('This field is required.'),
  outsideUS180days: string().required('This field is required.'),
  suspendedDriversLicense: string().required('This field is required.'),
  dui5years: string().required('This field is required.'),
  movingViolations5Years: string().required('This field is required.'),
  numberofMovingViolations: string().when('movingViolations5Years', {
    is: "true",
    then: (schema) => schema.required('This field is required.'),
    otherwise: (schema) => schema.notRequired()
  })
});

PersonalHistory.DefaultFormState = (prefill = false) => {
  return {
    extremeSports: prefill ? "false" : "",
    flights: prefill ? "false" : "",
    felony: prefill ? "false" : "",
    bannedCountries: prefill ? "false" : "",
    outsideUS180days: prefill ? "false" : "",
    suspendedDriversLicense: prefill ? "false" : "",
    dui5years: prefill ? "false" : "",
    movingViolations5Years: prefill ? "false" : "",
    numberofMovingViolations: prefill ? "1" : ""
  };
};
